'use strict';
const Api_Ids = {
    FORM_SEARCH_API_ID: 1,
    USER_SEARCH_API_ID: 2
};

/*** @description Authentication type enum for API connections */
enum AuthType {
    None = 0,
    OAuth = 1,
}

export {
    Api_Ids,
    AuthType
}


// WEBPACK FOOTER //
// ./client/components/constants/api.connection.constants.ts